'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const buttonBase = "_button-base_hlu6r_1";
const styles = {
	buttonBase: buttonBase
};

const ButtonBase = (_a) => {
  var { children, className, isDisabled = false, isPending = false, size = "medium", variant = "primary" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isDisabled", "isPending", "size", "variant"]);
  return React__default.default.createElement(reactAriaComponents.Button, Object.assign({ "aria-busy": isPending, "aria-label": isPending ? "pending" : props["aria-label"], "aria-live": isPending ? "polite" : void 0, className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx.clsx(dynamicClassName, styles.buttonBase);
  }, "data-a11y-ignore": variant === "brand" ? "color-contrast" : void 0, "data-zds": true, "data-size": size, "data-variant": variant, isDisabled: isDisabled || isPending, isPending }, props), (buttonRenderProps) => typeof children === "function" ? children(buttonRenderProps) : children);
};

exports.ButtonBase = ButtonBase;
//# sourceMappingURL=ButtonBase.cjs.js.map
